import { gql } from '@apollo/client';

export const REPUBLISH_ESTATE = gql`
  mutation RepublishEstate($estateId: Int!) {
    republishEstate(estateId: $estateId)
  }
`;
